import { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { staffErrorText } from './staffText';

const EMPTY = { firstName: '', lastName: '', email: '' };

/** Alta (sin contraseña: la persona la define con el link del mail) y edición de los datos de una cuenta. */
const StaffFormModal = ({ open, staff, onClose, onSubmit }) => {
  const isEdit = Boolean(staff);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setForm(staff ? { firstName: staff.firstName, lastName: staff.lastName, email: staff.email } : EMPTY);
    setSaving(false);
    setError('');
  }, [open, staff]);

  const set = (field) => (event) => setForm((prev) => ({ ...prev, [field]: event.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!form.firstName.trim() || !form.lastName.trim() || !form.email.trim()) {
      setError('Completá todos los campos.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(form.email.trim())) {
      setError('Ingresá un correo válido.');
      return;
    }
    setSaving(true);
    try {
      await onSubmit({ firstName: form.firstName.trim(), lastName: form.lastName.trim(), email: form.email.trim().toLowerCase() });
    } catch (err) {
      setError(staffErrorText(err));
      setSaving(false);
    }
  };

  const emailChanged = isEdit && form.email.trim().toLowerCase() !== staff.email;

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{isEdit ? 'Editar persona' : 'Nueva persona'}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            {!isEdit && (
              <Typography variant="body2" color="text.secondary">
                No se define contraseña: le llega un mail con un link para que la elija ella o él.
              </Typography>
            )}
            <TextField label="Nombre" value={form.firstName} onChange={set('firstName')} size="small" autoFocus fullWidth />
            <TextField label="Apellido" value={form.lastName} onChange={set('lastName')} size="small" fullWidth />
            <TextField
              label="Correo"
              value={form.email}
              onChange={set('email')}
              size="small"
              fullWidth
              inputProps={{ autoCapitalize: 'none', spellCheck: false }}
            />
            {emailChanged && (
              <Alert severity="warning">
                Cambiar el correo cierra todas las sesiones de esta cuenta.
                {staff?.passwordPending ? ' Se envía una nueva invitación al correo nuevo.' : ''}
              </Alert>
            )}
            {error && <Alert severity="error">{error}</Alert>}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={saving}>Cancelar</Button>
          <LoadingButton type="submit" variant="contained" loading={saving}>
            {isEdit ? 'Guardar' : 'Crear y enviar invitación'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default StaffFormModal;
